/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../../Library';
import { Document } from '../../../core/models/Document';
import { Node } from '../../../core/models/Node';

export abstract class AbstractReferenceLocalizationStrategy {
    PREFIX : string;

    /**
     * Warning: This method assumes that the definition and the represented object can be read from the same JSON,
     * i.e. effectively contain the same data.
     * @param {Node} source
     * @param {Node} target
     * @param {Document} model
     * @return {Node}
     */
    wrap<T extends Node>(source : Node, target : T, model : Document) : T {
        target._ownerDocument = model;
        target._parent = target;
        return <T><any>Library.readNode(Library.writeNode(source), target);
    }

    transform(source : any, transformName : (p1: string) => string, result : any) {
        if(result == null) throw Object.defineProperty(new Error("Result argument is null."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.IllegalArgumentException','java.lang.Exception'] });
        if(source != null) {
            {
                let array178 = /* entrySet */(o => { let s = []; for (let e in o) s.push({ k: e, v: o[e], getKey: function() { return this.k }, getValue: function() { return this.v } }); return s; })(source);
                for(let index177=0; index177 < array178.length; index177++) {
                    let e = array178[index177];
                    {
                        /* put */(result[(target => (typeof target === 'function')?target(e.getKey()):(<any>target).apply(e.getKey()))(transformName)] = <any>e.getValue());
                    }
                }
            }
        }
    }

    constructor() {
        this.PREFIX = "#/components/";
    }
}
AbstractReferenceLocalizationStrategy["__class"] = "io.apicurio.datamodels.openapi.visitors.dereference.AbstractReferenceLocalizationStrategy";



